// src/locales/index.ts
export type LocaleKey = 'ru' | 'ky' | 'tr'

export const supportedLocales: Array<{ code: LocaleKey; name: string; nativeName: string }> = [
  { code: 'ru', name: 'Russian', nativeName: 'Русский' },
  { code: 'ky', name: 'Kyrgyz', nativeName: 'Кыргызча' },
  { code: 'tr', name: 'Turkish', nativeName: 'Türkçe' },
]

// Each language is its own chunk: a visitor downloads only the one on screen
// (plus Russian later, as the fallback for a missing key). See useI18n.
export const localeLoaders: Record<LocaleKey, () => Promise<{ default: any }>> = {
  ru: () => import('./ru'),
  ky: () => import('./ky'),
  tr: () => import('./tr'),
}
